<template>
  <Card class="ed-grid m-grid-2 s-to-center">
    <template #header>
      <section class="card call-to-action__text">
        <div class="s-center s-to-center m-to-left">
         <section class="m-left">
           <h1>{{ props.titulo }}</h1>
          <p>{{ props.parrafo }}</p>
         </section>
          <!-- bottones para pantallas más grandes -->
          <article v-if="tamaño > 480" class="m-left">
            <Button
              class="boton-primario"
              :label="props.nombreBoton"
              v-on:click.prevent="EnviarARegistro"
              v-if="
                props.nombreBoton == '¡Quiero Empezar!' ||
                props.nombreBoton == '¡comienza a practicar!' ||
                props.nombreBoton == '¡Sí Quiero Un Portafolio Profesional!'
              "
            />
            <Button
              class="boton-primario"
              :label="props.nombreBoton"
              v-on:click.prevent="requerimientoProyecto"
              v-if="props.nombreBoton == 'Buscar proyecto aleatorio'"
            />
          </article>
        </div>
      </section>
    </template>
    <template #content>
      <div class="card s-center">
        <!-- comparamos que la propiedad enviada sea igual al valor
          de la variable declarada y que cumpla la condicion -->
        <img :src="props.nombreImagen" :alt="props.titulo" />
      </div>
    </template>
    <template #footer>
      <!-- botones para pantallas mas pequeñas -->
      <section class="card call-to-action__text" v-if="tamaño < 480">
        <div class="s-to-center lg-left">
          <br />
          <Button
            class="boton-primario"
            :label="props.nombreBoton"
            v-on:click.prevent="EnviarARegistro"
            v-if="
              props.nombreBoton == 'Registrarse' ||
              props.nombreBoton == '¡comienza a practicar!'
            "
          />
          <br />
          <Button
            class="boton-primario"
            :label="props.nombreBoton"
            v-on:click.prevent="requerimientoProyecto"
            v-if="props.nombreBoton == 'Buscar proyecto aleatorio'"
          />
        </div>
      </section>
    </template>
  </Card>
</template>
<script>
import { ref, computed } from "vue";
import router from "../../router";
import { useStore } from "vuex";
import Button from "primevue/button";
import Card from "primevue/card";
export default {
  /* se reciben tres parametros, el titulo, parrafo y texto de imagen para comparaar
    con la variable local */
  props: {
    titulo: null,
    parrafo: {
      type: String,
      required: true,
    },
    nombreImagen: {
      type: String,
      required: true,
    },
    nombreBoton: {
      type: String,
      required: true,
    },
  },

  setup(props) {
    const EnviarARegistro = () => {
      router.push({ name: "registro" });
    };
    const store = useStore();

    let proyectos = computed(() => {
      return store.state.proyectos.todosLosProyectos;
    });

    let proyectosUsuario = computed(() => {
      return store.state.usuario.proyectosUsuario;
    });

    /* revisar si proyectos y proyectosUsuario son diferentes y retornarlos*/
    let proyectosNoUsuario = computed(() => {
      return proyectos.value.filter((proyecto) => {
        return !proyectosUsuario.value.find((proyectoUsuario) => {
          return proyectoUsuario.id === proyecto.id;
        });
      });
    });
    /* funcion para proyectos random */
    function requerimientoProyecto() {
      let proyectoRandom = Math.floor(
        Math.random() * proyectosNoUsuario.value.length
      );
      let idProyecto = proyectosNoUsuario.value[proyectoRandom].id;

      router.push({
        name: "proyectoId",
        params: {
          id: idProyecto,
        },
      });
    }
    let idea = ref("idea");

    /* para saber el tamaño de la pantalla */
    let tamaño = ref(0);
    tamaño.value = window.screen.width;
    setInterval(() => {
      tamaño.value = window.screen.width;
    }, 1000);

    return {
      EnviarARegistro,
      props,
      idea,
      requerimientoProyecto,
      tamaño,
    };
  },
  components: {
    Button,
    Card,
  },
};
</script>

<style lang="scss" scoped>
@import "../../sass/call-to-action.scss";
.boton-primario{
  width:240px;
  height: 40px;
}
</style> 